// @mui material components
import Card from "@mui/material/Card";
import React, { useState, useEffect, useRef, useContext } from "react";

// HG Pro components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// HG Pro examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftButton from "components/SoftButton";
import Checkbox from "@mui/material/Checkbox";

import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

import MailIcon from '@mui/icons-material/Mail';

import MenuItem from "@mui/material/MenuItem";
import swal from 'sweetalert2';

// HG Pro components
import SoftInput from "components/SoftInput";

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import PrintIcon from '@mui/icons-material/Print';

import Table_th from "examples/Tables/table_without_th";

import Table from "@mui/material/Table";

import { TableHead, TableRow, TableCell } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableBody from "@mui/material/TableBody";

import SoftAvatar from "components/SoftAvatar";


import EditFormPopup from "layouts/vendor-directory/form";

import getCSRFToken from 'csrftoken';
import AuthContext from "context/AuthContext";
import { useSoftUIController, setselectedPropertyId, } from "context";
import refreshAccessToken from "adminRefresToken";

import Edit_Vendor from "layouts/vendor-directory/form/Edit_Vendor";
import LanguageIcon from '@mui/icons-material/Language';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

function Tables() {
  const {
    adminauthTokens,
    authTokens,
    managerauthTokens,
    staffauthTokens,
    logoutUser,
  } = useContext(AuthContext);

  const selectedAuthToken = managerauthTokens || staffauthTokens;
  const [controller, dispatch] = useSoftUIController();
  const { selectedPropertyId, openShiftLog } = controller;

  const [incidentsData, setIncidentsData] = useState([]);

  useEffect(() => {
    fetchSelectedProperty();
    fetchVendors();
    if (selectedPropertyId) {
      fetchSelectedProperty();
    }
  }, [selectedPropertyId]);

  const fetchSelectedProperty = async () => {
    try {
      const newAccessToken = await refreshAccessToken(selectedAuthToken?.refresh);
      const response = await fetch("https://hgpro.nyc/manager/api/my/selected/property", {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCSRFToken(),
          'Authorization': `Bearer ${newAccessToken}`,
        },
        credentials: 'include',

      });

      const data = await response.json();
      setselectedPropertyId(dispatch, data.property_id);
    } catch (error) {
      console.error("Error fetching selected property:", error);
    }
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [filteredData, setFilteredData] = useState([]);

  const [orderBy, setOrderBy] = useState(""); // Initially, no column is selected for sorting
  const [order, setOrder] = useState("asc");

  const [data, setData] = useState([]); // State to store the fetched data
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const fetchVendors = async () => {
    try {
      const newAccessToken = await refreshAccessToken(
        selectedAuthToken?.refresh
      );
      const response = await fetch(`https://hgpro.nyc/manager/api/${selectedPropertyId}/vendor`,
        {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
            'Authorization': `Bearer ${newAccessToken}`,
          },
          credentials: 'include',
        }
      );

      const vendorsData = await response.json();
      //console.log(vendorsData);
      setData(vendorsData.vendors);
      setFilteredData(vendorsData.vendors)

    } catch (error) {
      console.error("Error fetching selected property:", error);
    }
  };

  const deleteVendors = async (vendor_id) => {
    try {
      const newAccessToken = await refreshAccessToken(
        selectedAuthToken?.refresh
      );
      const response = await fetch(`https://hgpro.nyc/manager/api/${selectedPropertyId}/vendor/update/${vendor_id}`,
        {
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken(),
            'Authorization': `Bearer ${newAccessToken}`,
          },
          credentials: 'include',
        }
      );
      if (response.status === 200) {
        //console.log('Vendor Deleted successfully');

        swal.fire({
          title: "Vendor Deleted successfully.",
          icon: "success",
          toast: true,
          timer: 3000,
          position: 'bottom-right',
          timerProgressBar: true,
          showConfirmButton: false,
        });
        fetchVendors();
        // Perform any additional actions upon successful submission
      } else {
        console.error('Failed to remove vendor');
        console.error("Error adding event:", response.statusText);
        swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to remove vendor. Please try again later.',
          toast: true,
          timer: 3000,
          position: 'bottom-right',
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }



    } catch (error) {
      console.error("Error fetching selected property:", error);
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return (a, b) => {
      if (order === "asc") {
        return a[orderBy] < b[orderBy] ? -1 : 1;
      } else {
        return b[orderBy] < a[orderBy] ? -1 : 1;
      }
    };
  }

  const [vendorToEdit, setVendorToEdit] = useState(null);

  useEffect(() => {

    // Filter the data based on the search query
    const filteredVendors = data.filter((vendor) => {
      const query = searchQuery.toLowerCase();
      return (
        vendor.companyName.toLowerCase().includes(query) ||
        vendor.category.toLowerCase().includes(query) ||
        vendor.email.toLowerCase().includes(query) ||
        query === "" // Show all data when the search query is empty
      );
    });

    setFilteredData(filteredVendors);
  }, [selectedPropertyId, searchQuery]);

  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" p={1} style={{ borderBottom: "1px solid grey" }}>
              <SoftTypography variant="h6">Vendor List - The HgPro</SoftTypography>
              <SoftBox display="flex">
                <SoftButton variant="outlined" color="info" size="small" style={{ margin: "3px" }} >
                  Export to Excel
                </SoftButton>
                <SoftButton variant="outlined" color="info" size="small" style={{ margin: "3px" }} onClick={() => setIsPopupOpen(true)} >
                  + Add More Vendors from Master List
                </SoftButton>
              </SoftBox>
              {isPopupOpen && (
                <EditFormPopup
                  onClose={() => {
                    setIsPopupOpen(false);
                    fetchVendors();
                  }}
                />
              )}
            </SoftBox>
            <SoftBox style={{ margin: "5px" }}>
              <SoftInput type="search" placeholder="Search Vendor..." value={searchQuery}
                onChange={handleSearchInputChange} />
            </SoftBox>
            {selectedPropertyId !== undefined && (
              <>
                <Card style={{ marginTop: "10px" }}>
                  <SoftBox>
                    <SoftBox
                      p={1}
                      sx={{
                        backgroundColor: "grey",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, 0)}
                      >
                        <FirstPageIcon />
                      </SoftButton>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                      >
                        <ArrowBackIosIcon />
                      </SoftButton>
                      <SoftTypography
                        variant="h6"
                        fontSize="small"
                        color="white"
                        p={1}
                      >
                        {page + 1}
                      </SoftTypography>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, page + 1)}
                        disabled={page >= Math.ceil(data.length / rowsPerPage) - 1}
                      >
                        <ArrowForwardIosIcon />
                      </SoftButton>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() =>
                          handleChangePage(
                            null,
                            Math.ceil(data.length / rowsPerPage) - 1
                          )
                        }
                        disabled={page >= Math.ceil(data.length / rowsPerPage) - 1}
                      >
                        <LastPageIcon />
                      </SoftButton>
                      <SoftTypography
                        variant="h6"
                        fontSize="small"
                        color="white"
                        p={1}
                      >
                        Page {page + 1} of {Math.ceil(data.length / rowsPerPage)}
                      </SoftTypography>
                    </SoftBox>
                    <TableContainer>
                      <Table
                        sx={{
                          "& .MuiTableRow-root": {
                            "& td": {
                              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                `${borderWidth[1]} solid ${borderColor}`,
                              border: ({ borders: { borderWidth, borderColor } }) =>
                                `${borderWidth[1]} solid ${borderColor}`,
                            },
                          },
                        }}
                      >
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              Name
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderBy === "category"}
                                direction={orderBy === "category" ? order : "asc"}
                                onClick={() => handleSortRequest("category")}
                              >
                                Category
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderBy === "streetAddress"}
                                direction={orderBy === "streetAddress" ? order : "asc"}
                                onClick={() => handleSortRequest("streetAddress")}
                              >
                                Address
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel

                              >
                                City
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>Zip</TableCell>
                            <TableCell>
                              Phone
                            </TableCell>
                            <TableCell>Assign to Maintenance</TableCell>
                            <TableCell>

                              Vendor Compliance
                            </TableCell>
                            <TableCell>

                              Contact Vendor
                            </TableCell>
                            <TableCell>

                              Action
                            </TableCell>
                          </TableRow>
                          {/* Pagination logic to display rows based on page and rowsPerPage */}
                          {stableSort(filteredData, getComparator(order, orderBy))
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((vendor, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  {vendor.companyName}
                                </TableCell>
                                <TableCell>{vendor.category}</TableCell>
                                <TableCell>{vendor.streetAddress}</TableCell>
                                <TableCell>{vendor.city}</TableCell>
                                <TableCell>{vendor.selectedState}</TableCell>
                                <TableCell>{vendor.zipCode}</TableCell>
                                <TableCell>{vendor.phone}</TableCell>
                                <TableCell>
                                  {vendor.trackVendorCompliance ? (
                                    <span>
                                      <b style={{ fontSize: '24px', color: "green" }} ><DoneIcon /></b>
                                    </span>
                                  ) : null}
                                </TableCell>
                                <TableCell>{vendor.vendorComplianceStatus}</TableCell>
                                <TableCell>
                                  <a href={`${vendor.websiteUrl}`} style={{ fontSize: '24px' }} ><LanguageIcon /></a>
                                  <a href={`mailto:${vendor.email}`} style={{ fontSize: '24px' }} ><MailIcon /></a>
                                </TableCell>


                                {
                                  selectedAuthToken && (
                                    <TableCell>
                                      <span
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        style={{ margin: "3px", fontSize: '24px', color: "green", cursor: "pointer" }}
                                        onClick={() => setVendorToEdit(vendor)}
                                      >
                                        <EditIcon />
                                      </span>
                                      <span
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        style={{ margin: "3px", fontSize: '24px', color: "red", cursor: "pointer" }}
                                        onClick={() => deleteVendors(vendor.vendor_id)}
                                      >
                                        <DeleteIcon />
                                      </span>
                                    </TableCell>
                                  )
                                }

                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* Pagination component */}
                    <SoftBox
                      p={1}
                      sx={{
                        backgroundColor: "grey",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, 0)}
                      >
                        <FirstPageIcon />
                      </SoftButton>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                      >
                        <ArrowBackIosIcon />
                      </SoftButton>
                      <SoftTypography
                        variant="h6"
                        fontSize="small"
                        color="white"
                        p={1}
                      >
                        {page + 1}
                      </SoftTypography>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() => handleChangePage(null, page + 1)}
                        disabled={page >= Math.ceil(data.length / rowsPerPage) - 1}
                      >
                        <ArrowForwardIosIcon />
                      </SoftButton>
                      <SoftButton
                        variant="outlined"
                        size="small"
                        iconOnly
                        square
                        onClick={() =>
                          handleChangePage(
                            null,
                            Math.ceil(data.length / rowsPerPage) - 1
                          )
                        }
                        disabled={page >= Math.ceil(data.length / rowsPerPage) - 1}
                      >
                        <LastPageIcon />
                      </SoftButton>
                      <SoftTypography
                        variant="h6"
                        fontSize="small"
                        color="white"
                        p={1}
                      >
                        Page {page + 1} of {Math.ceil(data.length / rowsPerPage)}
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>

                  {vendorToEdit && (
                    <Edit_Vendor
                      propertyId={selectedPropertyId}
                      vendor_data={vendorToEdit}
                      onSave={() => {
                        setVendorToEdit(null); // Reset the userToEdit state after saving the changes
                        fetchVendors();
                      }}
                      onClose={() => {
                        setVendorToEdit(null);
                        fetchVendors();
                      }// Reset the userToEdit state if the edit is canceled
                      }
                    />
                  )}

                </Card>
              </>
            )}
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout >
  );
}

export default Tables;
